
<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('add') }} {{ $t('receipts') }} {{ $t('templates') }}</div>
      <div>
        <router-link
          class="btn-blue"
          to="receipts-template"
        >{{ $t('receipts') }} {{ $t('templates') }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                v-model="receipttemp_name"
                placeholder="."
                id="template_name"
                name="template_name"
                type="text"
              />
              <label>{{ $t('templates') }} {{ $t('name') }}</label>
            </div>
            <img src="@/assets/img/icons/question.svg" height="20" width="20" class="ml-2" />
          </div>
          <p class="error_message">
            <span
              v-if="submitted && errors.has('template_name')"
            >{{ errors.first('template_name') }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t('active') }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox v-model="receipt_is_active" name="check-button" switch></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >{{ $t('save') }}</button>
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(false)"
            class="btn-blue"
          >{{ $t('saveaddmore') }}</button>
          <button @click.prevent.stop="OnReset()" class="btn-black">{{ $t('reset') }}</button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="receipts-template"
          >{{ $t('cancel') }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      submitted: false,
      receipttemp_name: "",
      receipt_is_active: true
    };
  },
  methods: {
    OnReset: function() {
      this.receipttemp_name = "";
      this.receipt_is_active = true;
    },
    OnFinalSubmit: function(flag) {
      this.submitted = true;

      this.$validator.validate().then(valid => {
        if (valid) {
          this.btenable = true;
          let payload = {
            temp_name: this.receipttemp_name,
            temp_is_active: this.receipt_is_active
          };
          MasterService.AddReceiptTemplate(payload)
            .then(response => {
              this.btenable = false;
              const { data } = response;

              if (data.status) {
                this.OnReset();
                this.$toasted.show(data.message);

                if (flag) {
                  this.$router.push({
                    path: "/master/receipts-template"
                  });
                } else {
                  this.submitted = false;
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    }
  }
};
</script>

<style scoped>
.w-62 {
  width: 62%;
}

.h20 {
  height: 50%;
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/ReceiptsTemplate/addReceiptsTemplate.vue